module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pv"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihart0007#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihart0008#pt01"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("1:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EARLY")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MODERN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MARKETPLACE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ITS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("COLONIAL")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ENCOUNTER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihart0009#ch01"
    }
  }, [_vm._v("1   A Journey through Early Modern Trading Spaces")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihart0010#ch02"
    }
  }, [_vm._v("2   The Market Turned Upside Down")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihart0011#pt02"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("REMAKING")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MARKETPLACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihart0012#ch03"
    }
  }, [_vm._v("3   Making a Colonial Marketplace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihart0013#ch04"
    }
  }, [_vm._v("4   The Resurgence of Early Modern Market Values")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihart0014#pt03"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("3:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CONFRONTING")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("COLONIAL")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MARKETPLACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihart0015#ch05"
    }
  }, [_vm._v("5   Revolution in the Marketplace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihart0016#ch06"
    }
  }, [_vm._v("6   Making a Republican Marketplace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihart0017#conc"
    }
  }, [_vm._v("Conclusion: Constitution Making and the Marketplace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihart0018#epil"
    }
  }, [_vm._v("Epilogue: The Colonial Marketplace’s American Legacy")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihart0019#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihart0020#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chihart0022#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-614f336e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-hart-0006.vue
// module id = 69
// module chunks = 0